<div class="casino-lobby-games casino-game-tile-wrapper casino-lobby-width-gametile casino-toggle-widget">
    <h2 class="game-tile-heading casino-lobby-header" [class]="headerClass()">
        <cc-categoryicon-subtitle [lobbyType]="lobbyType()" [subCategory]="category()" [recentAndGyml]="recentAndGyml"> </cc-categoryicon-subtitle>
        <div [style.width]="toggleWidth()" [style.marginRight]="toggleMarginRight()">
            <ds-segmented-control
                class="rp-fav-toggle-widget"
                style="--ds-segment-item-text-max-width: auto"
                csAppearanceThemeModifier
                [fullWidth]="true"
                [activeOption]="activeOption()"
                [elementType]="uiElement"
                [featureName]="featureName"
                [currentTheme]="currentTheme()"
                (activeOptionChange)="optionChange($event)">
                @for (option of controlOptions; track option.name) {
                    <ds-segmented-option [name]="option.name" [title]="option.title" />
                }
            </ds-segmented-control>
        </div>
    </h2>

    <div class="scrollable-games" [style.overflow-x]="!isTouch() ? 'hidden' : 'scroll'" [class.non-touch-scrollable-games]="!isTouch()">
        @if (validGames.length) {
            <cc-feature-grid
                #featureGrid
                [games]="validGames"
                [subcategory]="category().categoryInfo"
                [isTouch]="isTouch()"
                [Type]="'scrollable-games'"
                [gameLaunchedFrom]="category().categoryInfo.categoryid"
                [lobbyType]="lobbyType()"
                [newFeatureGridArr]="newFeatureGridArr"
                [customGrid]="customGrid()">
                <div class="see-all-tile" seeAll>
                    @if (games() && games().length > maxGameLength()) {
                        <div class="see-all-grid">
                            @for (i of seeAllArray; track i) {
                                <div class="see-all-block"></div>
                            }
                        </div>
                        <div class="see-all-content" (keyup)="seeAll()" (click)="seeAll()">
                            <cc-global-translate [key]="'SeeAll'"></cc-global-translate>
                            <vn-icon name="theme-right" size="16"></vn-icon>
                        </div>
                    }
                </div>
            </cc-feature-grid>
        } @else {
            <div class="empty-games text-center text-white mx-5" [class]="{ 'px-5': !isBwinTheme() }">
                <cc-global-translate [key]="emptyScreenMessage"></cc-global-translate>
            </div>
        }
    </div>
</div>
